import * as React from 'react'

import * as Styled from './styles'

export const BaselineImage: React.FC<{
  imageSrc: string | undefined
  title: string
  children?: React.ReactNode
}> = ({ imageSrc, title, children }) => {
  return (
    <Styled.Body>
      {imageSrc ? (
        <Styled.ImageWrapper>
          <Styled.Image
            alt={title}
            aspectRatios={{
              sm: 15 / 20,
              md: 15 / 20,
            }}
            src={imageSrc}
            loading='default'
            fetchPriority='high'
            widths={{ unit: 'px', sm: 150, md: 150 }}
          />
        </Styled.ImageWrapper>
      ) : null}
      <Styled.Content>
        <Styled.Title>{title}</Styled.Title>
        {children}
      </Styled.Content>
    </Styled.Body>
  )
}
